@if (isLoading()) {
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 py-6">
  <!-- Skeleton Loaders -->
  @for (i of [1, 2, 3, 4, 5, 6]; track i) {
  <div
    [@fadeIn]
    class=" rounded-lg overflow-hidden shadow-lg flex flex-col sm:flex-row h-full relative"
  >
    <!-- Skeleton Tooltip for Open/Closed at the top -->
    <div class="absolute top-2 left-0 right-0 flex justify-center">
      <ngx-skeleton-loader
        [theme]="{
          height: '28px',
          width: '100px',
          'background-color': '#E5E7EB',
          'border-radius': '9999px'
        }"
      ></ngx-skeleton-loader>
    </div>

    <!-- Skeleton Image -->
    <div class="relative sm:w-2/5 md:w-1/3">
      <ngx-skeleton-loader
        [theme]="{
          height: '192px',
          'background-color': '#E5E7EB',
          'border-radius': '0'
        }"
      ></ngx-skeleton-loader>
      <div class="absolute top-2 right-2">
        <ngx-skeleton-loader
          [theme]="{
            width: '50px',
            height: '24px',
            'background-color': '#F3F4F6',
            'border-radius': '9999px'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <!-- Skeleton Info -->
    <div class="p-4 sm:p-6 sm:w-3/5 md:w-2/3">
      <!-- Title -->
      <ngx-skeleton-loader
        [theme]="{
          height: '28px',
          width: '80%',
          'background-color': '#E5E7EB',
          margin: '0 0 12px 0'
        }"
      ></ngx-skeleton-loader>

      <!-- Address -->
      <div class="flex items-center mb-2">
        <ngx-skeleton-loader
          [theme]="{
            height: '20px',
            width: '90%',
            'background-color': '#E5E7EB'
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Business Hours Box -->
      <div class="bg-amber-50 p-3 rounded-md mb-3">
        <div class="flex items-center mb-1">
          <ngx-skeleton-loader
            [theme]="{
              height: '20px',
              width: '60%',
              'background-color': '#F3F4F6'
            }"
          ></ngx-skeleton-loader>
        </div>
        <ngx-skeleton-loader
          [theme]="{
            height: '16px',
            width: '40%',
            'background-color': '#F3F4F6'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
  }
</div>
}

<!-- Actual content when loaded -->
@if (!isLoading() && establishments().length > 0) {
<div
  class=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 py-4 sm:py-6 px-2 sm:px-0"
>
  @for (establishment of establishments(); track establishment.id_restaurant) {
  <div
    [@fadeIn]
    [ngClass]="{
      'bg-gray-500 text-white': !isInRange(establishment.inRange)
    }"
    class="bg-white text-white cursor-pointer hover:shadow-xl transition-all duration-300 restaurant-card rounded-2xl shadow-md relative overflow-hidden border border-gray-100"
    (click)="establishment.inRange && onVisitClick(establishment)"
  >
    <!-- Favorite Heart Button -->
    <div class="absolute top-3 right-3 z-30">
      <establishment-main-favorite-establihshment
        [isFavorite]="establishment.isFavorite"
        [restaurantId]="establishment.id_restaurant"
        (favoriteToggled)="onFavoriteToggled(establishment, $event)"
      ></establishment-main-favorite-establihshment>
    </div>

      <!-- Status Badge -->
      <div class="absolute top-3 left-3 z-20">
        <div [appIsOpen]="isRestaurantOpen(establishment)"></div>
      </div>

    <!-- Out of Zone Badge -->
    @if (!isInRange(establishment.inRange)) {
    <div class="absolute top-3 right-14 z-20">
      <div
        class="status-badge inline-flex items-center px-2 py-1 rounded-full text-xs font-medium shadow-sm bg-red-500 text-white"
      >
        <span class="text-xs font-semibold"> Fuera de zona </span>
      </div>
    </div>
    }

    <!-- Restaurant Image -->
    <div class="relative h-32 sm:h-36 bg-gray-100 overflow-hidden">
      <img
        class="restaurant-image w-full h-full object-cover"
        [src]="getImageUrl(establishment.picture_logo)"
        [alt]="establishment.name_restaurant"
        (error)="onImageError($event)"
      />
    </div>

    <!-- Restaurant Info -->
    <div class="p-4">
      <!-- Restaurant Name -->
      <h3 class="text-lg font-bold text-gray-900 mb-2 line-clamp-1">
        {{ establishment.name_restaurant }}
      </h3>

      <!-- Quick Info Row -->
      <div
        class="quick-info flex items-center justify-between mb-3 text-sm text-gray-600"
      >
        <div class="info-item flex items-center space-x-1">
          <i class="fas fa-map-marker-alt text-blue-500 text-xs"></i>
          <span class="font-medium">{{
            formatDistance(establishment.distance)
          }}</span>
        </div>
        <div class="info-item flex items-center space-x-1">
          <i class="far fa-clock text-purple-500 text-xs"></i>
          <span class="font-medium">{{ establishment.time_order }} min</span>
        </div>
        <!-- <div class="info-item flex items-center space-x-1">
              <i class="fas fa-truck text-green-500 text-xs"></i>
              <span class="font-semibold text-green-600">
                {{ establishment.costo_envio.toFixed(0) | currency : "MX" : "symbol" : "1.0-0" }}
              </span>
            </div> -->
      </div>

      <!-- Business Hours -->
      <div class="business-hours bg-gray-50 p-3 rounded-lg">
        <div class="flex items-center text-gray-700 mb-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-2 text-amber-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span class="font-medium text-sm">Horario</span>
        </div>
        @if (establishment.apertura && establishment.cierre) {
        <div class="text-sm text-gray-600 font-medium">
          {{ formatTime(establishment.apertura) }} -
          {{ formatTime(establishment.cierre) }}
        </div>
        }
        <div>
          <div class="flex items-center justify-between">
            <div class="text-sm text-gray-600 font-medium">
              Promedio de calificación
            </div>
            <div class="flex items-center">
              <div class="flex">
                @for (star of [1, 2, 3, 4, 5]; track star) { @if
                (establishment.avgStart && establishment.avgStart > 0) { @if
                (star <= getStarRating(establishment.avgStart)) {
                <i class="fas fa-star text-amber-400"></i>
                } @else if (isHalfStar(star, establishment.avgStart)) {
                <i class="fas fa-star-half-alt text-amber-400"></i>
                } @else {
                <i class="far fa-star text-amber-400"></i>
                } } @else {
                <i class="far fa-star text-amber-400"></i>
                } }
              </div>
              <span class="ml-1 text-sm text-gray-600 font-medium">
                @if (establishment.avgStart && establishment.avgStart > 0) { ({{
                  formatRating(establishment.avgStart)
                }}) } @else { (Sin calificaciones) }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
}
